export default __webpack_public_path__ + "static/media/car1.94f27a72.png";